export type DtFilter =
  | 'கோவில் மரபுகள்'
  | 'பண்டிகைகள்'
  | 'தெய்வச் சின்னங்கள்'
  | 'குடும்ப மரபுகள்'
  | 'பெருமாள்'
  | 'விநாயகர்'

export interface DtRelatedLink {
  label: string
  to: string
}

export interface DtEpisode {
  id: string
  number: number
  anchor: string
  titleTa: string
  cardTag: string
  hookTa: string
  bodyTa: string
  noteTa?: string
  youtubeVideoId: string
  published: string
  filters: DtFilter[]
  related: DtRelatedLink[]
}

export const DT_FILTERS: DtFilter[] = [
  'கோவில் மரபுகள்',
  'பண்டிகைகள்',
  'தெய்வச் சின்னங்கள்',
  'குடும்ப மரபுகள்',
  'பெருமாள்',
  'விநாயகர்',
]

export const DT_SERIES = {
  path: '/deiveegam-theriyuma',
  h1: 'தெய்வீகம் தெரியுமா? - தமிழ் ஆன்மீக தகவல்கள் & கோவில் மரபுகள்',
  seoTitle: 'தெய்வீகம் தெரியுமா? | தமிழ் ஆன்மீக தகவல்கள் & கோவில் மரபுகள் | Deiveega Oosai',
  seoDescription:
    'கோவில் மரபுகள், புரட்டாசி, விநாயகர், பெருமாள், சடாரி, மகாளய அமாவாசை உள்ளிட்ட ஆன்மீக தகவல்களின் 12 குறும் பகுதிகள் - தெய்வீகம் தெரியுமா?',
  heroTitle: 'தெய்வீகம் தெரியுமா?',
  heroSupport:
    'நம் கோவில் மரபுகள், ஆன்மீகச் சின்னங்கள், பண்டிகைகள் மற்றும் வழிபாட்டு பழக்கங்களின் பின்னால் இருக்கும் அர்த்தங்களை ஒரு நிமிடத்தில் அறிந்துகொள்வோம்.',
  introTa:
    '“தெய்வீகம் தெரியுமா?” என்பது தெய்வீக ஓசையின் குறுந்தகவல் தொடர். நாம் கோவிலில் தினமும் காணும் ஒரு வழக்கம், வீட்டில் தலைமுறைகளாகப் பின்பற்றும் ஒரு மரபு, பண்டிகையின் பின்னணி, அல்லது ஒரு ஆன்மீகச் சின்னம் - “ஏன் இப்படிச் செய்கிறோம்?” என்ற கேள்விக்கு எளிய தமிழில் சுருக்கமாக விளக்கம் தருவது இந்தத் தொடரின் நோக்கம். ஒவ்வொரு பகுதியிலும் முதலில் குறும் வீடியோவைப் பாருங்கள்; கீழே அதற்கான கூடுதல் பின்னணி மற்றும் முக்கியக் குறிப்புகளையும் படிக்கலாம்.',
  disclaimerTa:
    'இந்தத் தொடரில் பகிரப்படும் சில விளக்கங்கள் புராணங்கள், ஆகம/சமய மரபுகள், நாட்டுப்புற நம்பிக்கைகள் மற்றும் பகுதி/குடும்ப வழக்கங்களின் அடிப்படையில் அமையலாம். நடைமுறைகள் இடம், குடும்பம், சம்பிரதாயம் ஆகியவற்றின்படி மாறலாம். இவை உறுதி செய்யப்பட்ட ஆரோக்கிய, பண, ஜோதிட அல்லது வாழ்க்கை பலன்களை வாக்குறுதி செய்யாது.',
} as const

/** Newest first (DT12 → DT01). Episode numbers keep series chronology. */
export const DT_EPISODES: DtEpisode[] = [
  {
    id: 'dt-12',
    number: 12,
    anchor: 'dt-12',
    titleTa: 'மகாளய அமாவாசை ஏன் விசேஷம்?',
    cardTag: 'முன்னோர் நினைவு • அமாவாசை',
    hookTa: 'சர்வ பித்ரு அமாவாசை எனக் கூறப்படும் மகாளய அமாவாசையின் முக்கிய கருத்து - முன்னோர்களை நன்றியுடன் நினைவுகூருதல்.',
    bodyTa:
      'மகாளய அமாவாசை, பித்ரு பக்ஷத்தின் நிறைவு நாளாகவும் பல மரபுகளில் “சர்வ பித்ரு அமாவாசை” எனவும் குறிப்பிடப்படுகிறது. முன்னோரின் திதி தெரியாதவர்கள் அல்லது குறிப்பிட்ட நாளில் வழிபாடு செய்ய முடியாதவர்கள் அனைவரையும் ஒன்றாக நினைவுகூரும் நாளாக இது பார்க்கப்படுகிறது. தர்ப்பணம், தானம், குடும்ப வழிபாடு போன்ற நடைமுறைகள் பிராந்தியம், சமூகம், குடும்ப சம்பிரதாயம் ஆகியவற்றின்படி மாறும். இந்தப் பகுதியின் மையம் பயம் அல்லது தோஷம் அல்ல; நம்மை உருவாக்கிய முன்னோர்களுக்கு நன்றி, நினைவு மற்றும் மரியாதை செலுத்தும் நாள் என்ற நேர்மறையான கருத்தாகும்.',
    noteTa: 'முன்னோர் நினைவு நேர்மறையான தொனியில்; சடங்குகள் குடும்பம்/பிராந்தியத்தின்படி மாறும்.',
    youtubeVideoId: 'GUZtzJunhgA',
    published: '2026-10-06',
    filters: ['பண்டிகைகள்', 'குடும்ப மரபுகள்'],
    related: [
      { label: 'ஆன்மீக தகவல்கள்', to: '/spiritual' },
      { label: 'புரட்டாசி சனிக்கிழமை', to: '/deiveegam-theriyuma#dt-09' },
    ],
  },
  {
    id: 'dt-11',
    number: 11,
    anchor: 'dt-11',
    titleTa: 'எலுமிச்சை-மிளகாய் & வாகன பூஜை - ஏன்?',
    cardTag: 'நாட்டுப்புற மரபு • வாகன பூஜை',
    hookTa: 'புது வண்டியில் எலுமிச்சை, மிளகாய் பயன்படுத்தும் வழக்கம் சாஸ்திரக் கட்டாயமா, நாட்டுப்புற நம்பிக்கையா?',
    bodyTa:
      'புது வண்டி வாங்கும்போது எலுமிச்சை-மிளகாய் கட்டுவது அல்லது டயரின் கீழ் எலுமிச்சை வைத்து வாகன பூஜை செய்வது இந்தியாவின் பல பகுதிகளில் காணப்படும் நாட்டுப்புற/குடும்ப வழக்கம். திருஷ்டி, அலட்சுமி போன்ற கருத்துகளோடு இதை இணைக்கும் கதைகள் பரவலாக உள்ளன. ஆனால் இது எல்லா இந்து சாஸ்திரங்களிலும் கட்டாயப்படுத்தப்பட்ட ஒரே விதி என்று கூற முடியாது. வாகன பூஜை நன்றி மற்றும் மங்களமான தொடக்கத்தின் குறியீடாக இருக்கலாம்; எலுமிச்சை வைப்பது வாகனத்தின் இயந்திர/சாலை பாதுகாப்பை மாற்றாது.',
    noteTa: 'சாலைப் பாதுகாப்பு: இந்த சடங்கு safe driving, helmet/seat belt அல்லது வாகன பராமரிப்புக்கு மாற்றாக அல்ல.',
    youtubeVideoId: 'PR-iwXrXueQ',
    published: '2026-10-03',
    filters: ['குடும்ப மரபுகள்', 'தெய்வச் சின்னங்கள்'],
    related: [
      { label: 'கோவில் மணி ஏன்?', to: '/deiveegam-theriyuma#dt-03' },
      { label: 'குலதெய்வ வழிபாடு', to: '/deiveegam-theriyuma#dt-05' },
    ],
  },
  {
    id: 'dt-10',
    number: 10,
    anchor: 'dt-10',
    titleTa: 'பெருமாள் கோவிலில் தலையில் வைக்கும் சடாரி / சடகோபம் ஏன்?',
    cardTag: 'வைணவ மரபு • சடாரி',
    hookTa: 'தலையில் ஏற்றுக்கொள்ளும் சடாரி, பெருமாளின் திருவடி மற்றும் சரணாகதி உணர்வை எப்படிக் குறிக்கிறது?',
    bodyTa:
      'பெருமாள் கோவில்களில் தீர்த்தம் மற்றும் துளசி பெற்றபின் தலையில் வைக்கப்படும் புனிதச் சின்னம் சடாரி அல்லது சடகோபம் என்று அழைக்கப்படுகிறது. வைணவ மரபில் அது பெருமாளின் திருவடிகளோடு தொடர்புடையதாகக் கருதப்படுகிறது; அதைத் தலையில் ஏற்றுக்கொள்வது தாழ்மை, சரணாகதி மற்றும் பக்தியின் நினைவூட்டலாக விளக்கப்படுகிறது. கோவில்/சம்பிரதாயத்தின்படி வடிவம் மற்றும் நடைமுறை மாறலாம். அடுத்த முறை சடாரி பெறும்போது “இறைவனின் திருவடிகளை தலைமேல் ஏற்றுக்கொள்கிறேன்” என்ற உணர்வுடன் தரிசிக்கலாம்.',
    youtubeVideoId: '_URta164Ytc',
    published: '2026-10-01',
    filters: ['பெருமாள்', 'கோவில் மரபுகள்'],
    related: [
      { label: 'விஷ்ணு & கிருஷ்ணன்', to: '/deities/vishnu' },
      { label: 'ஸ்ரீ வேங்கடேச ஸ்தோத்திரம்', to: '/content/sri-venkatesa-stotram-tamil-lyrics' },
      { label: 'கோவிந்தா நாமாவளி', to: '/content/govinda-namavali-tamil' },
    ],
  },
  {
    id: 'dt-09',
    number: 9,
    anchor: 'dt-09',
    titleTa: 'புரட்டாசி சனிக்கிழமை ஏன் ஸ்பெஷல்? சனி பகவானுக்கு தொடர்பு என்ன?',
    cardTag: 'புரட்டாசி • பெருமாள்',
    hookTa: 'புரட்டாசி சனிக்கிழமை வழிபாடு, மாவிளக்கு, “கோவிந்தா” நாமஸ்மரணம் ஆகிய மரபுகளின் பின்னணி.',
    bodyTa:
      'புரட்டாசி மாத சனிக்கிழமைகள் பெருமாள் வழிபாட்டிற்கு சிறப்பாகக் கடைப்பிடிக்கப்படுகின்றன. விரதம், மாவிளக்கு, கோவிந்த நாமஸ்மரணம், திருப்பதி/பெருமாள் தரிசனம் போன்ற வழக்கங்கள் பல குடும்பங்களில் தலைமுறையாக உள்ளன. பெருமாள் வழிபாடு சனி தொடர்பான கெடுபலன்களிலிருந்து காக்கும் என்று பக்தி/ஜோதிட மரபில் நம்பிக்கைகள் சொல்லப்படுகின்றன; அதை உறுதி செய்யப்பட்ட ஜோதிட விளைவு என்று கூற முடியாது. குடும்ப மரபு மாறலாம் என்பதையும் நினைவில் கொள்ளுங்கள்.',
    noteTa: 'சனி தொடர்பான காப்பு நம்பிக்கை பாரம்பரியக் கருத்து; உத்தரவாதமான ஜோதிட முடிவு அல்ல.',
    youtubeVideoId: 'cFBBOxnXegA',
    published: '2026-09-26',
    filters: ['பண்டிகைகள்', 'பெருமாள்'],
    related: [
      { label: 'ஸ்ரீ வேங்கடேச ஸ்தோத்திரம்', to: '/content/sri-venkatesa-stotram-tamil-lyrics' },
      { label: 'கோவிந்தா நாமாவளி', to: '/content/govinda-namavali-tamil' },
      { label: 'கண்ணீரோடு வந்தேனே', to: '/content/kanneerodu-vandhene-govinda-song' },
      { label: '108 விஷ்ணு நாமங்கள்', to: '/content/vishnu-108-names-tamil' },
    ],
  },
  {
    id: 'dt-08',
    number: 8,
    anchor: 'dt-08',
    titleTa: 'சாமிக்கு ஏன் வாகனம்? வாகனங்களின் மறைபொருள்',
    cardTag: 'தெய்வச் சின்னங்கள் • வாகனம்',
    hookTa: 'மூஞ்சூறு, சிங்கம், அன்னப்பறவை - தெய்வ வாகனங்களை வாழ்க்கைத் தத்துவமாக எப்படி வாசிக்கலாம்?',
    bodyTa:
      'தெய்வங்களின் வாகனங்களை வெறும் போக்குவரத்து வடிவமாக மட்டுமே அல்லாமல் ஆன்மீகச் சின்னங்களாகவும் பலர் விளக்குகிறார்கள். விநாயகரின் மூஞ்சூறு கட்டுப்படுத்த வேண்டிய அலைபாயும் மனத்தை நினைவூட்டலாம்; துர்கையின் சிங்கம் வீரத்தை தர்மத்தின் வழியில் செலுத்தும் சக்தியாக வாசிக்கப்படுகிறது; சரஸ்வதியின் அன்னப்பறவை நல்லது-தவறை பிரித்தறியும் விவேகத்துடன் தொடர்புபடுத்தப்படுகிறது. இவை பயனுள்ள குறியீட்டு விளக்கங்கள்; வேத/ஆகமத்தில் அதிகாரப்பூர்வமாக வகுக்கப்பட்ட ஒரே வகைப்பாடு அல்ல.',
    noteTa: 'மூன்று உதாரணங்களும் interpretive symbolism — அதிகாரப்பூர்வ வேத/ஆகம வகைப்பாடு அல்ல.',
    youtubeVideoId: 'PArm3MxUpTM',
    published: '2026-09-24',
    filters: ['தெய்வச் சின்னங்கள்', 'விநாயகர்'],
    related: [
      { label: 'ஆன்மீக தகவல்கள்', to: '/spiritual' },
      { label: 'தெய்வங்கள்', to: '/deities' },
    ],
  },
  {
    id: 'dt-07',
    number: 7,
    anchor: 'dt-07',
    titleTa: 'கோவிலில் செல்போன் தடை: சரியா? தவறா?',
    cardTag: 'கோவில் • தரிசன ஒழுக்கம்',
    hookTa: 'தரிசன நேரத்தில் mobile distraction-ஐ குறைப்பது ஆன்மீக அனுபவத்தை மேம்படுத்துமா?',
    bodyTa:
      'தரிசனம் என்பது படம் எடுப்பதற்கான ஒரு நொடி மட்டுமல்ல; மனம் முழுவதும் இறைவன் மீது செல்லும் பக்தி அனுபவம். செல்போன், அறிவிப்புகள், புகைப்படம் எடுக்கும் கவலை போன்றவை அந்த ஒருமுகத்தன்மையை சிதறடிக்கலாம். அதனால் சில கோவில்கள் செல்போன்/கேமரா பயன்பாட்டை கட்டுப்படுத்துகின்றன. ஆனால் தமிழ்நாட்டின் அனைத்து கோவில்களிலும் ஒரே சட்டம் என்று பொதுமைப்படுத்த முடியாது; விதிகள் கோவில் நிர்வாகத்தின்படி மாறும். நீங்கள் செல்லும் கோவிலின் விதிகளை மதித்து, தரிசன நேரத்தில் சில நிமிடங்கள் digital distraction-ஐ ஒதுக்கி வைப்பது பயனுள்ள பக்தி பழக்கமாக இருக்கலாம்.',
    noteTa: 'செல்போன்/கேமரா விதிகள் கோவில் நிர்வாகத்தின்படி மாறும்.',
    youtubeVideoId: 'QtqGLkytsGs',
    published: '2026-09-22',
    filters: ['கோவில் மரபுகள்'],
    related: [
      { label: 'கருவறை ஏன் இருட்டாக?', to: '/deiveegam-theriyuma#dt-02' },
      { label: 'கோவில் மணி ஏன்?', to: '/deiveegam-theriyuma#dt-03' },
    ],
  },
  {
    id: 'dt-06',
    number: 6,
    anchor: 'dt-06',
    titleTa: 'புரட்டாசியில் அசைவம் ஏன் தவிர்க்கப்படுகிறது?',
    cardTag: 'புரட்டாசி • உணவு & விரதம்',
    hookTa: 'புரட்டாசி மாதத்தில் சைவ உணவு, விரதம் மற்றும் பெருமாள் வழிபாடு எப்படி தொடர்புபடுத்தப்படுகிறது?',
    bodyTa:
      'புரட்டாசி மாதம் பெருமாள் வழிபாட்டிற்கு சிறப்பாகக் கடைப்பிடிக்கப்படும் காலமாக பல தமிழ் குடும்பங்களில் உள்ளது. அந்த மாதத்தில் சைவ உணவு எடுத்துக்கொள்வது, விரதம் அல்லது எளிய உணவு பழக்கத்தைப் பின்பற்றுவது பக்தி ஒழுக்கத்தின் ஒரு பகுதியாக சில குடும்பங்களில் தொடர்கிறது. இது எல்லா இந்துக்களுக்கும் கட்டாயமான ஒரே விதி அல்ல; சிலர் மாதம் முழுவதும், சிலர் சனிக்கிழமைகளில் மட்டுமே, சிலர் வேறு குடும்ப மரபுப்படி கடைப்பிடிக்கலாம். உணவுக் கட்டுப்பாடு தொடர்பான உடல்நலத் தேவைகள் இருப்பின் தனிநபர் சூழ்நிலையை முன்னிலைப்படுத்த வேண்டும்.',
    noteTa: 'குடும்ப மரபு மாறலாம்; உணவு/உடல்நல அறிவுரை அல்ல.',
    youtubeVideoId: 'iO6gqAdgbCE',
    published: '2026-09-20',
    filters: ['பண்டிகைகள்', 'பெருமாள்', 'குடும்ப மரபுகள்'],
    related: [
      { label: 'புரட்டாசி சனிக்கிழமை', to: '/deiveegam-theriyuma#dt-09' },
      { label: 'ஸ்ரீ வேங்கடேச ஸ்தோத்திரம்', to: '/content/sri-venkatesa-stotram-tamil-lyrics' },
      { label: 'கோவிந்தா நாமாவளி', to: '/content/govinda-namavali-tamil' },
      { label: 'கண்ணீரோடு வந்தேனே', to: '/content/kanneerodu-vandhene-govinda-song' },
    ],
  },
  {
    id: 'dt-05',
    number: 5,
    anchor: 'dt-05',
    titleTa: 'குலதெய்வ வழிபாடு ஏன் முக்கியம்?',
    cardTag: 'குடும்ப மரபு • குலதெய்வம்',
    hookTa: 'குடும்பத்தின் தலைமுறை நினைவு, அடையாளம் மற்றும் வழிபாட்டோடு குலதெய்வம் எப்படி இணைகிறது?',
    bodyTa:
      'குலதெய்வ வழிபாடு பல தமிழ் குடும்பங்களில் தலைமுறைகளாகத் தொடரும் முக்கியமான மரபாக உள்ளது. ஒரு குடும்பத்தின் பூர்வீக ஊர், முன்னோர் வழிபாட்டு நினைவு மற்றும் குடும்ப அடையாளத்துடன் குலதெய்வம் இணைந்து காணப்படலாம். “main switch” போன்ற உவமை நினைவில் நிற்க உதவும்; ஆனால் “குலதெய்வ வழிபாடு இல்லாமல் வேறு எந்த வழிபாடும் பலன் தராது” என்ற உத்தரவாதமாக இதைக் கூற முடியாது. குடும்ப மரபை அறிந்த மூத்தவர்களிடம் கேட்டு, தங்கள் சம்பிரதாயப்படி வழிபடுவது சிறந்தது. வேண்டுதல் அல்லது பரிகார பலன் எதுவும் உறுதி செய்யப்படாது.',
    noteTa: 'பலன் உத்தரவாதம் இல்லை; குடும்ப மரபை மதித்து வழிபடுங்கள்.',
    youtubeVideoId: 'ZgltCtUz_xY',
    published: '2026-09-18',
    filters: ['குடும்ப மரபுகள்'],
    related: [
      { label: 'தெய்வங்கள்', to: '/deities' },
      { label: 'ஆன்மீக தகவல்கள்', to: '/spiritual' },
    ],
  },
  {
    id: 'dt-04',
    number: 4,
    anchor: 'dt-04',
    titleTa: 'உலகத்தை படைத்த பிரம்மாவுக்கே கோவில்கள் குறைவா? காரணம் என்ன?',
    cardTag: 'புராணக் கதை • பிரம்மா',
    hookTa: 'பிரம்மாவுக்கான தனிக் கோவில்கள் ஒப்பீட்டளவில் குறைவாக இருப்பதற்கு புராணங்களில் என்ன கதைகள் சொல்லப்படுகின்றன?',
    bodyTa:
      'பிரம்மாவுக்கான தனிக் கோவில்கள் சிவன் அல்லது விஷ்ணு கோவில்களைப் போல அதிகமாக இல்லாததை விளக்க பல புராண மரபுக் கதைகள் சொல்லப்படுகின்றன. சிவபுராண மரபில் பிரம்மா-விஷ்ணு இடையேயான முடிவில்லா ஜோதி சம்பவம் குறிப்பிடப்படுகிறது; புஷ்கர் மரபில் சாவித்திரி தொடர்பான சாபக் கதையும் சொல்லப்படுகிறது. இவை மத மரபில் சொல்லப்படும் புராண விளக்கங்கள் - வரலாற்று ஆய்வு மூலம் நிரூபிக்கப்பட்ட ஒரே காரணம் அல்ல. ராஜஸ்தானின் புஷ்கர் பிரம்மா கோவில் இந்த தலைப்பை அறிமுகப்படுத்த உதவும் குறிப்பிடத்தக்க உதாரணம்.',
    noteTa: 'புராண/பாரம்பரிய விளக்கம் — verified history அல்ல.',
    youtubeVideoId: 'GH6R4TRS6yQ',
    published: '2026-09-16',
    filters: ['தெய்வச் சின்னங்கள்', 'கோவில் மரபுகள்'],
    related: [
      { label: 'ஆன்மீக தகவல்கள்', to: '/spiritual' },
      { label: 'தெய்வ வாகனங்கள்', to: '/deiveegam-theriyuma#dt-08' },
    ],
  },
  {
    id: 'dt-03',
    number: 3,
    anchor: 'dt-03',
    titleTa: 'கோவிலில் மணி அடிப்பது ஏன்?',
    cardTag: 'கோவில் • வழிபாட்டு மரபு',
    hookTa: 'கோவில் மணி ஓசை நம்மை “இப்போது தரிசனத்திற்கு வந்திருக்கிறோம்” என்று நினைவூட்டும் அழைப்பா?',
    bodyTa:
      'கோவிலுக்குள் செல்லும்போது மணி அடிப்பது பல இடங்களில் காணப்படும் வழக்கம். மணி ஓசை ஒரு தெளிவான கவன மாற்றத்தை உருவாக்கி, வெளியுலக சிந்தனைகளிலிருந்து மனதை வழிபாட்டின் மீது திருப்ப உதவுகிறது என்ற ஆன்மீக விளக்கம் பரவலாக உள்ளது. சிலர் அதிர்வு, சக்தி மையங்கள் போன்ற விளக்கங்களையும் கூறினாலும் அவற்றை நிரூபிக்கப்பட்ட அறிவியல் உண்மையாக எழுத முடியாது. “மணி ஓசை - மனதைத் திருப்பும் புனித நினைவூட்டல்” என்ற அளவான விளக்கமே இங்கு மையம். கோவில் விதிகளுக்கு ஏற்ப மணியைப் பயன்படுத்த வேண்டும்.',
    noteTa: '“அறிவியல் ரீதியாக நிரூபிக்கப்பட்ட சக்கரங்கள்” போன்ற வார்த்தைகளைத் தவிர்க்கவும்.',
    youtubeVideoId: 'Xki0Knb_VSM',
    published: '2026-09-15',
    filters: ['கோவில் மரபுகள்'],
    related: [
      { label: 'கருவறை ஏன் இருட்டாக?', to: '/deiveegam-theriyuma#dt-02' },
      { label: 'செல்போன் தடை', to: '/deiveegam-theriyuma#dt-07' },
    ],
  },
  {
    id: 'dt-02',
    number: 2,
    anchor: 'dt-02',
    titleTa: 'கோவில் கருவறை மட்டும் ஏன் இருட்டாக இருக்கிறது?',
    cardTag: 'கோவில் • கருவறை',
    hookTa: 'கருவறையின் குறைந்த வெளிச்சமும் தீபாராதனையும் தரிசன அனுபவத்தை எப்படி மாற்றுகிறது?',
    bodyTa:
      'பல பாரம்பரிய கோவில்களில் கருவறை வெளிப்புற மண்டபங்களை விட குறைந்த வெளிச்சத்துடன் இருக்கும். கருவறையின் கட்டமைப்பு, புனித மையமாகக் கருதப்படும் அதன் தன்மை மற்றும் தீபாராதனையின் ஒளி - இவை அனைத்தும் பக்தரின் கவனத்தை மூலவரின் திருவுருவத்தின் மீது ஒருமுகப்படுத்த உதவும் அனுபவத்தை உருவாக்குகின்றன. “கருவறை எப்போதும் இருட்டாக இருக்க வேண்டும்” என்ற ஒரே விதியாக இதை எழுத முடியாது; கோவில், காலம், மின்விளக்கு அமைப்பு ஆகியவற்றின்படி நடைமுறை மாறலாம். முக்கிய கருத்து: வெளிச்சத்தின் அளவு அல்ல, அமைதியுடன் தரிசனத்தில் மனதைச் செலுத்துவது.',
    youtubeVideoId: 'n78tHNNIgTI',
    published: '2026-09-13',
    filters: ['கோவில் மரபுகள்'],
    related: [
      { label: 'கோவில் மணி ஏன்?', to: '/deiveegam-theriyuma#dt-03' },
      { label: 'செல்போன் தடை', to: '/deiveegam-theriyuma#dt-07' },
    ],
  },
  {
    id: 'dt-01',
    number: 1,
    anchor: 'dt-01',
    titleTa: 'விநாயகருக்கு அருகம்புல் ஏன் இவ்வளவு விசேஷம்?',
    cardTag: 'விநாயகர் • வழிபாட்டு மரபு',
    hookTa: 'அருகம்புல் (துர்வை) விநாயகர் வழிபாட்டில் ஏன் முக்கிய இடம் பெறுகிறது?',
    bodyTa:
      'விநாயகர் வழிபாட்டில் அருகம்புல் அல்லது துர்வை மிகவும் பரவலாகப் பயன்படுத்தப்படுகிறது. இதன் பின்னால் விநாயகரின் உஷ்ணத்தைத் தணித்தது போன்ற புராண/பாரம்பரியக் கதைகள் பல இடங்களில் சொல்லப்படுகின்றன. அதனால் அருகம்புல் வெறும் ஒரு புல் அல்ல; எளிமையான பொருளையும் பக்தியுடன் சமர்ப்பிக்கலாம் என்ற கருத்தையும் அது நினைவூட்டுகிறது. குடும்பம் அல்லது கோவில் மரபின்படி எண்ணிக்கை, சமர்ப்பிக்கும் முறை போன்றவை மாறலாம். இங்கு கதை “புராண மரபில் சொல்லப்படும் விளக்கம்” — ஒரே கட்டாயமான சாஸ்திர விதி அல்ல.',
    noteTa: 'புராண/பாரம்பரிய விளக்கம் — verified history அல்ல.',
    youtubeVideoId: 'urtWKp7TRPE',
    published: '2026-09-12',
    filters: ['விநாயகர்', 'கோவில் மரபுகள்'],
    related: [
      { label: 'விநாயகர்', to: '/deities/vinayagar' },
      { label: 'கணேச பஞ்சரத்னம்', to: '/content/ganesha-pancharatnam-tamil-lyrics-meaning' },
      { label: '108 விநாயகர் போற்றி', to: '/content/108-vinayagar-potri-tamil' },
    ],
  },
]
